const MyUrlmage = "/website"

export default MyUrlmage
